import {
  HIDE_TRIBUN_FEED_COUPON_REQUEST,
  HIDE_TRIBUN_FEED_COUPON_SUCCESS,
  HIDE_TRIBUN_FEED_COUPON_FAILURE
} from 'Store/constants';

const initialState = {
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case HIDE_TRIBUN_FEED_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case HIDE_TRIBUN_FEED_COUPON_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case HIDE_TRIBUN_FEED_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
